import { Card as AntCard, Flex } from "antd";
import styled from "styled-components";
import Text from "../text";
import React from "react";

const Styled = styled(AntCard)`
  padding: 0;
  overflow: hidden;
  border-radius: 2rem;
  box-shadow: none !important;
  .ant-card-head {
    border-bottom: none;
    min-height: unset;
    padding: 2.5rem 2.5rem;
  }
  .ant-card-actions {
    padding: 0;
    height: 2rem;
    border: none;
    li {
      margin: 0;
    }
  }
  .ant-card-body {
    padding: 3.5rem;
  }
  .header {
    padding-bottom: 3rem;
    .title {
      white-space: normal;
    }
  }
  ${(_) => (_.titleOnly || _.fixedHeader) && `.header { padding-bottom: 0; }`}
  ${(_) =>
    _.bordered &&
    `border-color: ${_.theme.token.fontColors.secondary};
     .header { padding-bottom: ${_.titleOnly ? 0 : 0.7}rem; }
     .ant-card-body { padding: 2.2rem !important; }
    `}
  ${(_) =>
    _.theme.mobile(
      `.ant-card-body { padding: 3rem 2rem;} 
      ${_.bordered && `.title { font-size: 2rem;  }`}`
    )}
  ${(_) =>
    !!_.background &&
    `background: ${
      _.background.includes("url")
        ? `${_.theme.token.actions.tertiary} ${_.background} right/cover no-repeat`
        : _.background
    };`}
`;

const Card = ({
  title,
  type = "",
  children,
  bordered = false,
  extra,
  fixedHeader = false,
  classNames = {},
  ...props
}) => {
  const renderHeader = () => (
    <Flex justify="space-between" className={`header ${classNames.header}`}>
      {title &&
        (React.isValidElement(title) ? (
          title
        ) : (
          <Text
            weight={"700"}
            className="title"
            lineHeight={"2.42rem"}
            level={bordered ? 2 : 4}
            {...(typeof title === "object" ? title : { children: title })}
          />
        ))}
      {extra}
    </Flex>
  );

  return (
    <Styled
      bordered={bordered}
      titleOnly={!children}
      classNames={classNames}
      fixedHeader={fixedHeader}
      {...(fixedHeader && { title: renderHeader(), actions: [<div />] })}
      {...props}
    >
      {!fixedHeader && renderHeader()}
      {children}
    </Styled>
  );
};

export default Card;
